import Model from '~/models/base/Model';

/**
 * class representing general settings section data
 * @extends Model
 * @author fm
 */
export default class GeneralSettings extends Model {
    static _url = `${Model._url}/settings/`;

    static _urlChat = `${Model._chatBot}`;

    constructor(id = null, options) {
        super(id, options);
    }

    static getSystemSetting() {
        const requestUrl = `${this._url}system/`;
        const requestPayload = {}; // <<
        return this.api.get(requestUrl, requestPayload);
    }

    static saveSystemSettings(params) {
        const requestUrl = `${this._url}system/`;
        const requestPayload = params ?? {};
        return this.api.post(requestUrl, requestPayload);
    }

    static getInternationalSetting() {
        const requestUrl = `${this._url}international-settings/`;
        const requestPayload = {}; // <<
        return this.api.get(requestUrl, requestPayload);
    }

    static saveInternationalSettings(params) {
        const requestUrl = `${this._url}international-settings/`;
        const requestPayload = params ?? {};
        return this.api.post(requestUrl, requestPayload);
    }

    static getUsersSetting() {
        const requestUrl = `${this._url}users/`;
        const requestPayload = {}; // <<
        return this.api.get(requestUrl, requestPayload);
    }

    static saveUsersSettings(params) {
        const requestUrl = `${this._url}users/`;
        const requestPayload = params ?? {};
        return this.api.post(requestUrl, requestPayload);
    }

    static getPasswordPolicy() {
        const requestUrl = `${this._url}users/password-policy/`;
        return this.api.get(requestUrl);
    }

    static saveCalendar(params) {
        const requestUrl = `${this._url}calendar/`;
        const requestPayload = params ?? {};
        return this.api.post(requestUrl, requestPayload);
    }

    static saveHolidays(params) {
        const requestUrl = `${this._url}holidays/`;
        const requestPayload = params ?? {};
        return this.api.post(requestUrl, requestPayload);
    }

    static getIMSetting() {
        const requestUrl = `${this._url}instant-messaging/`;
        const requestPayload = {}; // <<
        return this.api.get(requestUrl, requestPayload);
    }

    static saveIMSettings(params) {
        const requestUrl = `${this._url}instant-messaging/`;
        const requestPayload = params ?? {};
        return this.api.post(requestUrl, requestPayload);
    }

    static getIncidentSetting() {
        const requestUrl = `${this._url}incidents/`;
        const requestPayload = {}; // <<
        return this.api.get(requestUrl, requestPayload);
    }

    static saveIncidentSettings(params) {
        const requestUrl = `${this._url}incidents/`;
        const requestPayload = params ?? {};
        return this.api.post(requestUrl, requestPayload);
    }

    static getPhasesSetting() {
        const requestUrl = `${this._url}phases/`;
        const requestPayload = {}; // <<
        return this.api.get(requestUrl, requestPayload);
    }

    static savePhasesSettings(params) {
        const requestUrl = `${this._url}phases/`;
        const requestPayload = params ?? {};
        return this.api.post(requestUrl, requestPayload);
    }

    static createPhasesSettings(params) {
        const requestUrl = `${this._url}phase/`;
        const requestPayload = params ?? {};
        return this.api.post(requestUrl, requestPayload);
    }

    static editPhasesSettings(params) {
        const requestUrl = `${this._url}phase/`;
        const requestPayload = params ?? {};
        return this.api.put(requestUrl, requestPayload);
    }

    static restorePhasesSettings(params) {
        const requestUrl = `${this._url}phase/`;
        const requestPayload = params ?? {};
        return this.api.patch(requestUrl, requestPayload);
    }

    static deletePhasesSettings(params) {
        const requestUrl = `${this._url}phase/`;
        const requestPayload = {
            data: params ?? {}
        };
        return this.api.delete(requestUrl, requestPayload);
    }

    static getTriageSetting() {
        const requestUrl = `${this._url}triage/`;
        const requestPayload = {}; // <<
        return this.api.get(requestUrl, requestPayload);
    }

    static saveTriageSettings(params) {
        const requestUrl = `${this._url}triage/`;
        const requestPayload = params ?? {};
        return this.api.post(requestUrl, requestPayload);
    }

    static getUserList() {
        const requestUrl = `${this._url}users-list/`;
        const requestPayload = {};
        return this.api.get(requestUrl, requestPayload);
    }

    static getMsspMasterLogin() {
        const requestUrl = `${this._url}mssp/remote-connect/`;
        const requestPayload = {};
        return this.api.get(requestUrl, requestPayload);
    }

    static setMsspMasterLogin(params) {
        const requestUrl = `${this._url}mssp/remote-connect/`;
        const requestPayload = params ?? {};
        return this.api.post(requestUrl, requestPayload);
    }

    static getIncidentLabels() {
        const requestUrl = `${this._url}incidents/label/`;
        return this.api.get(requestUrl);
    }

    static newLabel(params) {
        const requestUrl = `${this._url}incidents/label/`;
        const requestPayload = params ?? {};
        return this.api.post(requestUrl, requestPayload);
    }

    static deleteLabel(id) {
        const requestUrl = `${this._url}incidents/label/${id}/`;
        return this.api.delete(requestUrl);
    }

    static editLabel(id, params) {
        const requestUrl = `${this._url}incidents/label/${id}/`;
        const requestPayload = params ?? {};
        return this.api.post(requestUrl, requestPayload);
    }

    static toggleIncidentLabelFavorite(id) {
        const requestUrl = `${this._url}incidents/label/${id}/favorite/`;
        return this.api.patch(requestUrl);
    }

    static getChatStatus() {
        const requestUrl = `${this._urlChat}/check-slack-status/`;
        return this.api.get(requestUrl);
    }

    static getBridgeData() {
        const requestUrl = `${this._url}monitoring/bridge/`;
        return this.api.get(requestUrl);
    }

    static getCounter() {
        const requestUrl = `${this._publicApiUrl}/v3/monitoring/actions-counter/`;
        return this.api.get(requestUrl);
    }
}
